import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { LogIn } from 'lucide-react';

interface AuthTriggerProps {
  className?: string;
  variant?: 'header' | 'inline';
}

export const AuthTrigger: React.FC<AuthTriggerProps> = ({
  className = '',
  variant = 'header'
}) => {
  const navigate = useNavigate();

  const handleAuthClick = () => {
    navigate('/auth');
  };

  if (variant === 'header') {
    return (
      <div className={`flex items-center ${className}`}>
        <Button
          onClick={handleAuthClick}
          className="bg-[#e37300] hover:bg-[#c66500] text-white px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm font-bold transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 active:scale-95 flex items-center"
        >
          <LogIn className="h-3.5 w-3.5 sm:h-4 sm:w-4 mr-1.5 sm:mr-2" />
          <span className="hidden sm:inline">Sign In / Sign Up</span>
          <span className="sm:hidden">Sign In</span>
        </Button>
      </div>
    );
  }

  return (
    <div className={`flex ${className}`}>
      <Button
        onClick={handleAuthClick}
        className="w-full bg-[#e37300] hover:bg-[#c66500] text-white font-bold rounded-lg shadow-md py-2.5 transition-all duration-300"
      >
        <LogIn className="h-4 w-4 mr-2" />
        Sign In / Sign Up
      </Button>
    </div>
  );
};
